import {
    CORE_LOAD_MASTER_DATA_TUBE_SIZES_REQUEST,
    CORE_LOAD_MASTER_DATA_TUBE_SIZES_SUCCESS,
    CORE_LOAD_MASTER_DATA_TUBE_SIZES_FAILURE,

    CORE_LOAD_MASTER_DATA_TUBE_SIZE_REQUEST,
    CORE_LOAD_MASTER_DATA_TUBE_SIZE_SUCCESS,
    CORE_LOAD_MASTER_DATA_TUBE_SIZE_FAILURE,

} from '../../masterDataTypes'
import { REQUEST_STATE } from '../../types'

const requestState = REQUEST_STATE

export default {
    masterTubeSizes: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_TUBE_SIZES_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_TUBE_SIZES_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_LOAD_MASTER_DATA_TUBE_SIZES_FAILURE:
                return []
            default:
                return state
        }
    },
    masterTubeSize: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_TUBE_SIZE_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_TUBE_SIZE_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_LOAD_MASTER_DATA_TUBE_SIZE_FAILURE:
                return {}
            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/masterDatas/tubeSize.js